export default [
  /* ? HOME */
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      // pageTitle: 'Home',
      // breadcrumb: [
      //   {
      //     text: 'Home',
      //     active: true,
      //   },
      // ],
    },
  },

  /* ? LOGIN */
  {
    path: '/login',
    name: 'authLogin',
    component: () => import('@/views/auth/AppLogin.vue'),
    meta: {
      layout: 'full',
    },
  },

  /* ? WAREHOUSE */
  {
    path: '/warehouse',
    name: 'warehouse',
    component: () => import('@/views/warehouse/AppWarehouse.vue'),
    meta: {
      // pageTitle: 'Warehouse',
      // breadcrumb: [
      //   {
      //     text: 'Warehouse',
      //     active: true,
      //   },
      // ],
    },
  },

  /* ? PRODUCT */
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/product/AppProduct.vue'),
    meta: {
      // pageTitle: 'Product',
      // breadcrumb: [
      //   {
      //     text: 'Product',
      //     active: true,
      //   },
      // ],
    },
  },

  /* ? ORDER */
  {
    path: '/order',
    component: () => import('@/views/order/AppOrderView.vue'),
    meta: {
      // pageTitle: 'Order',
      // breadcrumb: [
      //   {
      //     text: 'Order',
      //     active: true,
      //   },
      // ],
    },
    children: [
      {
        path: '',
        name: 'order',
        component: () => import('@/views/order/AppOrder.vue'),
      },
      {
        path: ':id/details',
        name: 'order-details',
        component: () => import('@/views/order/AppOrderDetails.vue'),
      },
    ],
  },

  /* ? RECEPTION */
  {
    path: '/reception/:id',
    name: 'reception',
    component: () => import('@/views/reception/AppReception.vue'),
    meta: {
      // pageTitle: 'Reception',
      // breadcrumb: [
      //   {
      //     text: 'Reception',
      //     active: true,
      //   },
      // ],
    },
  },

  /* ? REGION */
  {
    path: '/region',
    component: () => import('@/views/region/AppRegionView.vue'),
    children: [
      {
        path: '',
        name: 'region',
        component: () => import('@/views/region/AppRegion.vue'),
        meta: {
          // pageTitle: 'Region',
          // breadcrumb: [
          //   {
          //     text: 'Region',
          //     active: true,
          //   },
          // ],
        },
      },

      /* ? DISTRICT */
      {
        path: ':id/district',
        name: 'district',
        component: () => import('@/views/district/AppDistrict.vue'),
        meta: {
          // pageTitle: 'District',
          // breadcrumb: [
          //   {
          //     text: 'District',
          //     active: true,
          //   },
          // ],
        },
      },
    ],
  },

  /* ? 404 */
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },

  /* ? NOT FOUND */
  {
    path: '*',
    redirect: 'error-404',
  },
]
